import { render, staticRenderFns } from "./TechnicalSupport.vue?vue&type=template&id=09e6f019&scoped=true&"
import script from "./TechnicalSupport.vue?vue&type=script&lang=js&"
export * from "./TechnicalSupport.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalSupport.vue?vue&type=style&index=0&id=09e6f019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e6f019",
  null
  
)

export default component.exports